<template>
  <div :class="$style.cols">
    <div :class="$style.col">
      <v-icon
        :class="$style.icon"
        color="primary darken-4"
      >
        mdi-clock-outline
      </v-icon>
      <time
        :time="time"
        :class="$style.text"
      >
        {{ time }} по Москве
      </time>
    </div>
    <div :class="$style.col">
      <div v-if="is_show_calendar()">
        <v-tooltip
          bottom
          color="primary darken-3"
          :open-delay="500"
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              :class="$style.notifications"
              @click="$emit('go_to_calendar')"
            >
              <span>
                <v-icon>mdi-calendar-blank-outline</v-icon>
                <Badge
                  v-if="today_events"
                  :color="'accent darken-4'"
                  :content="today_events"
                  offset-y="-1"
                  offset-x="10"
                />
              </span>
            </v-btn>
          </template>
          <span>
            Календарь
          </span>
        </v-tooltip>
      </div>
      <div v-else>
        <v-icon
          :class="$style.icon"
          color="primary darken-4"
        >
          mdi-calendar-blank-outline
        </v-icon>
      </div>
      <div :class="$style.text">
        {{ date }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { global_store, user_store } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { MenuPages } from '@/enums/menu';
import { Badge } from '../global/badge';

@Component({
  components: {
    Badge,
  },
})
export default class DateTimeComponent extends Vue {
  created() {
    // чтобы JS интерпретировал из unix timestamp в Date
    const server_time = this.current_time * 1000;
    const local_time = Date.now();
    const time_diff = server_time - local_time;

    this.interval = setInterval(() => {
      this.time = Intl.DateTimeFormat('ru-RU', {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'Europe/Moscow',
      }).format(Date.now() + time_diff);
    }, 1000);

    this.date = Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      timeZone: 'Europe/Moscow',
    }).format(server_time);
  }

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  get current_time() {
    return global_store.state.time;
  }

  get today_events() {
    return user_store.state.me?.today_events || null;
  }

  interval: ReturnType<typeof setInterval> | null = null;

  time: null | string = null;

  date: null | string = null;

  is_show_calendar() {
    const { available_pages } = user_store.state.me;
    const active_el = available_pages.find((sub_item) => sub_item.slug === MenuPages.CALENDAR);

    if (active_el && !active_el.is_active) {
      return false;
    } return true;
  }
}
</script>

<style module lang="scss">
.cols {
  display: flex;
  align-items: center;
}

.col {
  display: flex;
  align-items: center;
  margin-right: 24px;

  &:last-child {
    margin-right: 0;
  }
}

.text {
  color: $primary_darken3;
}

.icon {
  margin-right: 10px;
  color: $accent_darken4;
}

@media (max-width: 599px) {
  .col {
    margin-right: 22px;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .col {
    margin-right: 10px;
  }
}
</style>
